import { useContext } from 'react'
import TimedMetadataContext from './TimedMetadataContext'

const useTimedMetadata = () => {
  const { timedMetadata } = useContext(TimedMetadataContext)
  return [timedMetadata]
}

export default useTimedMetadata
